import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Dizest } from "src/libs/portal/dizest/dizest";

@Component({
    selector: 'wiz-page-page-access',
template: templateSource || '',
    styles: [``],
})
export class PagePageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {
        this.dizest = new Dizest(service);
    }

    public mode: string = 'password';

    public user: any = {
        id: '',
        password: ''
    };

    public async ngOnInit() {
        await this.service.init();
        this.mode = WizRoute.segment.mode ? WizRoute.segment.mode : 'password';

        const urlParams = new URLSearchParams(window.location.search);
        let redirectParam = urlParams.get('redirect');
        if (!redirectParam) redirectParam = "/";
        this.redirectParam = redirectParam;
        await this.service.auth.allow(false, this.redirectParam);
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: "Confirm",
            status: status
        });
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.user));
        let { code, data } = await this.dizest.api.call("auth", "login", user)
        if (code == 200) {
            location.href = this.redirectParam;
            return;
        }
        await this.alert(data);
    }
}

export default PagePageAccessComponent;